import api from './api';

export interface Review {
  id: string;
  rating: number;
  comment: string | null;
  createdAt: string;
  updatedAt: string;
  user: {
    id: string;
    name: string;
    email: string;
    avatar?: string | null;
  };
  product: {
    id: string;
    title: string;
  };
}

export interface CreateReviewDto {
  rating: number;
  comment?: string;
}

export const reviewService = {
  /**
   * Create a review for a product
   */
  async createReview(productId: string, reviewData: CreateReviewDto): Promise<Review> {
    const response = await api.post(`/products/${productId}/reviews`, reviewData);
    return response.data;
  },

  /**
   * Update a review
   */
  async updateReview(reviewId: string, reviewData: Partial<CreateReviewDto>): Promise<Review> {
    const response = await api.put(`/reviews/${reviewId}`, reviewData);
    return response.data;
  },

  /**
   * Delete a review
   */
  async deleteReview(reviewId: string): Promise<void> {
    await api.delete(`/reviews/${reviewId}`);
  },

  /**
   * Get all reviews for a product
   */
  async getProductReviews(productId: string): Promise<Review[]> {
    const response = await api.get(`/products/${productId}/reviews`);
    return response.data;
  },

  /**
   * Get current user's review for a product
   */
  async getMyReview(productId: string): Promise<Review | null> {
    try {
      const response = await api.get(`/products/${productId}/reviews/my-review`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
};

